import { render } from "./YearAheadReportsDashboard.vue?vue&type=template&id=3505a484&scoped=true"
import script from "./YearAheadReportsDashboard.vue?vue&type=script&lang=js"
export * from "./YearAheadReportsDashboard.vue?vue&type=script&lang=js"

import "./YearAheadReportsDashboard.vue?vue&type=style&index=0&id=3505a484&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3505a484"]])

export default __exports__